<template>
  <div class="header-container">
    <div class="header">
      <div class="plan png" @click="planClick('png')">
        <div class="header-icon">
          <img class="icon-img" src="@/assets/imgs/png-icon.png" alt />
        </div>
        <div class="header-title" :class="{active:isPngActive}">管道气</div>
      </div>
      <div class="line"></div>
      <div class="plan lng" @click="planClick('lng')">
        <div class="header-icon">
          <img class="icon-img" src="@/assets/imgs/lng-icon.png" alt />
        </div>
        <div class="header-title" :class="{active:isLngActive}">LNG</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HeaderTwo",
  props: {
    planType: String
  },
  data() {
    return {
      pType: ""
    };
  },
  computed: {
    isPngActive() {
      return this.planType == "png";
    },
    isLngActive() {
      return this.planType == "lng";
    }
  },
  methods: {
    planClick(type) {
      this.pType = type;
      this.$nextTick(() => {
        this.$emit("planTypeChange", this.pType);
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.header-container
  width 100%
  padding 24px 0
  background #F4F4F4
  display flex
  justify-content center
  .header
    width 702px
    height 120px
    background rgba(255, 255, 255, 1)
    box-shadow 0px 0px 20px rgba(0, 0, 0, 0.06)
    opacity 1
    border-radius 10px
    display flex
    justify-content space-between
    align-items center
    .line
      width 1px
      height 40px
      background rgba(227, 227, 227, 1)
      opacity 1
    .plan
      width 350px
      display flex
      .header-icon
        margin-left 48px
        display flex
        justify-content center
        .icon-img
          width 66px
          height 66px
      .header-title
        margin-left 16px
        font-size 32px
        font-weight 400
        line-height 66px
        opacity 1
      .active
        color #E12020
</style>
